var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1162",
    "data-name": "Group 1162",
    transform: "translate(-41 -260)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(41 260)",
    fill: "#041543"
  }), /*#__PURE__*/React.createElement("g", {
    id: "communications",
    transform: "translate(51 211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1164",
    "data-name": "Group 1164",
    transform: "translate(0 61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M18.242,61H1.758A1.761,1.761,0,0,0,0,62.758V74.477a1.761,1.761,0,0,0,1.758,1.758H18.242A1.761,1.761,0,0,0,20,74.477V62.758A1.761,1.761,0,0,0,18.242,61ZM18,62.172l-7.962,7.962L2.006,62.172ZM1.172,74.234V62.995l5.644,5.6ZM2,75.063l5.647-5.647,1.979,1.962a.586.586,0,0,0,.827,0l1.929-1.929L18,75.063Zm16.828-.829-5.617-5.617L18.828,63Z",
    transform: "translate(0 -61)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactEmailIcon);
export default __webpack_public_path__ + "static/media/contact-email-icon.068d5f15e2bc83ab77e585b9eea052e5.svg";
export { ForwardRef as ReactComponent };